import _find from "lodash/find";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ContactContext } from '../../../providers';
import { Button } from '../../elements/Button/Button';
import { Link } from '../../elements/Link/Link';
import PhoneNumber from '../../text/PhoneNumber/PhoneNumber';
import { jsx as ___EmotionJSX } from "@emotion/react";
function CallToAction(_ref) {
  let {
    showNumber,
    showMobileNumber
  } = _ref;
  return ___EmotionJSX(Button, {
    as: Link,
    to: '/contact'
  }, ___EmotionJSX(ContactContext.Consumer, null, context => {
    const number = _find(context.numbers, number => number.type === 'phone' && number.primary);
    const mobileNumber = _find(context.numbers, number => number.type === 'mobile' && number.primary);
    return ___EmotionJSX(React.Fragment, null, ___EmotionJSX("div", null, ___EmotionJSX(FormattedMessage, {
      id: "components.callToAction.content1"
    })), showNumber && ___EmotionJSX("div", null, ___EmotionJSX(PhoneNumber, {
      number: number.number,
      callable: false
    })), showMobileNumber && ___EmotionJSX("div", null, ___EmotionJSX(PhoneNumber, {
      number: mobileNumber.number,
      callable: false
    })), ___EmotionJSX("div", null, ___EmotionJSX(FormattedMessage, {
      id: "components.callToAction.content2"
    })));
  }));
}
CallToAction.defaultProps = {
  showNumber: true,
  showMobileNumber: false
};
export default CallToAction;